import { cn } from '@kiiwi/ui';
import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
};

const PreFooter = ({ children, className }: Props) => (
  <footer
    className={cn(
      'mx-auto mb-6 mt-12 w-full px-4 py-0 *:px-0 *:py-3 [&>:not(:first-child)]:border-t [&>:not(:first-child)]:border-neutral',
      className,
    )}
  >
    {children}
  </footer>
);

export default PreFooter;
